module.exports = __webpack_public_path__ + "img/mu.5b191b75.svg";